import React from 'react'
import { Dropdown, MenuItem } from 'react-bootstrap'
import i18next from 'i18next'

import { availableLanguages } from '../assets/translations/availableLanguages'
import analysisPagesIcon from './../assets/images/analysis-pages.png'

export default class SupportFileDownload extends React.Component {
  render() {
    const { label, files, icon } = this.props
    const languages = availableLanguages.filter(l => files[l.key])

    if (languages.length === 0) {
      return null
    }

    return (
      <Dropdown id={`support-download-${label}`} pullRight>
        <Dropdown.Toggle bsStyle="link" noCaret>
          <img src={icon || analysisPagesIcon} />

          <span>{label}</span>
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {languages.map((l, key) => (
            <MenuItem
              eventKey={key}
              key={key}
              onClick={() =>
                (window.location.href = `/api/support/download/${l.key}/${encodeURIComponent(
                  files[l.key]
                )}`)
              }
            >
              {i18next.t(l.translationKey)}
            </MenuItem>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SupportFileDownload.js